require('./jv.login.service.js');
require('../common/jv.common.parse-querystring.service');

angular.module('jv.login.controller', [
    'ngStorage',
    'jv.login.service',
    'jv.common.parse-querystring.service'
])
.controller('jvLoginController', [
    '$scope', '$window','$timeout','jvLoginService','TemplateLoader','jvFacebookService','$localStorage','parseQuerystring', 'GAService','$log',
    function($scope, $window, $timeout, jvLoginService, TemplateLoader, jvFacebookService, $localStorage,parseQuerystring, GAService,$log) {

        //initialize properties
        $scope.properties = window.properties;
        //page data
        $scope.pageData = window.pageData;

        $scope.data = {
            initialized: false,
            loginForm:{
                $submitted: false
            },
            forgotPasswordForm:{
                $submitted: false
            },
            socialAccounts:{}
        };

        $timeout(function(){
            $scope.data.initialized = true;
        },300);

        //not this user name
        $scope.notThisUser = function(){
            $scope.pageData.showPasswordView = false;
            $scope.data.username = $scope.pageData.jvUsername;
        };

        //validate user name
        var validateUsername = function(){
            var valid = $scope.data.username? true: false;
            return valid;
        };

        //validate password
        var validatePassword = function(){
            var valid = $scope.data.password? true: false;
            return valid;
        };
        
        //form validations
        var validateForm = function(){
            var  isFormValid = true;
            if(!validateUsername() || !validatePassword()){
                isFormValid = false;
            }
            return isFormValid;
        };


        var validateCaptcha = function(){
            return ($scope.data.grecaptcha.getResponse() !== '') ?  false: true;
        };

        //post login
        $scope.login = function(){
            $scope.data.loginForm.$submitted = true;
            //making sure we remove any existing errors on the page while validating for new ones.
            $scope.pageData.loginResponse = {};
            $scope.data.showCapchaError = false;
            if($scope.pageData.jvUsername && !angular.isDefined($scope.data.username)){
                $scope.data.username = $scope.pageData.jvUsername;
            }
            var isFormValid = validateForm();
            if(($scope.pageData.showPasswordView && validatePassword()) || (!$scope.pageData.showPasswordView && validateUsername())){
                isFormValid = true;
            }
            var isCaptchaEmpty = false;
            var isSSOLogin = $scope.data.ssologin;
            //validate capcha
            if($scope.pageData.recaptcha && angular.isDefined(grecaptcha) && $scope.pageData.showPasswordView){
                isCaptchaEmpty = validateCaptcha();
            }
            if(isCaptchaEmpty){
                $scope.data.showCapchaError = true;
            }
            if(isSSOLogin && $scope.pageData.jvUsername){
                isFormValid = true;
            }
            if(isFormValid && !isCaptchaEmpty){
                //ajax post
                /*
                var postData = {
                    username: $scope.data.username,
                    password: $scope.data.password,
                };
                jvLoginService.login(postData,function(response){
                    $scope.data.loginForm.$submitted = false;
                    console.log(response);
                });
                */
                return true;
            }else{
                return false;
            }
        };

        //Settings modal config
        $scope.modals = {
            forgotPassword : {
                show: false
            },
            disconnectAccount : {
                show: false
            }
        };

        //modal templates
        $scope.templates = TemplateLoader.register({
            forgotPassword: '/login/login/auth/modals/forgotPassword.html',
            disconnectAccount: '/login/login/auth/modals/disconnectAccount.html'
        });

        var facebookPermissions = ['public_profile'];

        //facebook social login
        var performFacebookLogin = function(response){
                if(!response){
                    return;
                }

                //set socialId
                $scope.data.socialId = response.userID;
                //$scope.data.socialId = '613031405';
                document.querySelector('#socialId').value = $scope.data.socialId;
                
                //set secret
                $scope.data.secret = response.accessToken;
                //$scope.data.secret = 'EAAAABIzMB3gBAKh72lkMRJ1yDzlxC2fAqRPKHBVdKouxIEoqPdApjtbxrF63sj1MrV51ISLZAkRGdDFsIX8oBE97DX9OY8eQchfu322ANScXQkvxqZCfVsghkjmAGapCpJFv8AEYOjpQNBwK9ahl4GfYMxnZBbHo8BEZC7pkwgZDZD';
                document.querySelector('#secret').value = $scope.data.secret;

                 //set platform
                $scope.data.platform = 0;
                document.querySelector('#platform').value = $scope.data.platform;

                //submit form
                $('#socialLoginForm').submit();
        };

        //multiple JV accounts with single social account login
        $scope.socialAccountsLogin = function(username){
                //set username
                $scope.data.socialAccounts.username  = username;
                document.querySelector('#socialAccounts-username').value = $scope.data.socialAccounts.username;

                //set socialId
                $scope.data.socialAccounts.socialId = $scope.pageData.socialProfiles.socialId;
                
                document.querySelector('#socialAccounts-socialId').value = $scope.data.socialAccounts.socialId;
                
                //set secret
                $scope.data.socialAccounts.secret = $scope.pageData.socialProfiles.secret;
                document.querySelector('#socialAccounts-secret').value = $scope.data.socialAccounts.secret;

                //set platform
                $scope.data.socialAccounts.platform = $scope.pageData.socialProfiles.platform;
                document.querySelector('#socialAccounts-platform').value = $scope.data.socialAccounts.platform;

                //submit form
                $('#socialAccountsForm').submit();
        };

        //show modal
        var showModal = function(modal){
            TemplateLoader.load(modal).then(function(){
                $scope.modals[modal].show = true;
            });
        };
        //hide modal
        $scope.hideModals = function(modal){
            $scope.modals[modal].show = false;
        };

        //show disconnect social account modal socialAccounts page
        $scope.showDisconnectAccountModal = function(username,index){
            $scope.data.socialAccounts.socialProfiles.username = username;
            $scope.data.socialAccounts.socialProfiles.index = index;
            showModal('disconnectAccount');
        };

        // disconnect social account from disconnect account modal on socialAccounts page
        $scope.disconnectSocialAccount = function(){

            var postData = {
                username:  $scope.data.socialAccounts.socialProfiles.username,
                secret: $scope.data.socialAccounts.socialProfiles.secret,
                socialId: $scope.data.socialAccounts.socialProfiles.socialId,
                platform: $scope.data.socialAccounts.socialProfiles.platform
            };
            
            jvLoginService.disconnectSocialAccount(postData,function(response){
                $scope.hideModals('disconnectAccount');
                if(response.status === 200 && response.data.success){
                    $scope.data.socialAccounts.socialProfiles.userAccounts.splice($scope.data.socialAccounts.socialProfiles.index,1);
                    $scope.$emit('showMessageBar', response.data.confirmationMessage);
                }else{
                    $scope.$emit('showMessageBar', response.data.errorMessage);
                }
            });
        };

        $scope.openUrl = function(url) {
            GAService.track('login-Promotion-URL');
            $window.open(url, '_blank');
        };

        //function to append the return URL
        var appendReturnURL = function(url,asFirstParam){
            var returnURL = parseQuerystring(window.location.href)['ReturnUrl'];
            if(returnURL){
                if(asFirstParam){
                    url += '?';
                }
                else{
                    url += '&';
                }
                url += 'ReturnUrl=' + returnURL;
            }

         return url;
      };

        //social login click event handler from login page
        $scope.socialLoginRedirect = function(socialLink){
            if(socialLink === 'facebook'){
                jvFacebookService.authorize(facebookPermissions, function(err, res){
                    if(res){
                        performFacebookLogin(res.authResponse);
                    }else{
                        $log.error(err);
                    }
                });
            }else{
                var linkedin = appendReturnURL($window.location.origin+'/TalentNetwork/connect.html?action=connect&skipSave=true&platform=1&callback='+$window.location.origin+'/login/action/socialLogin?platform=1',false);
                var twitter = appendReturnURL($window.location.origin+'/TalentNetwork/connect.html?action=connect&skipSave=true&platform=2&callback='+$window.location.origin+'/login/action/socialLogin?platform=2',false);
                var google = appendReturnURL($window.location.origin+'/admin/common/oidAuth.html?from=GoogleApps&newLogin=true',false);
                
                var socialLoginUrlMap = {
                    'linkedin' : linkedin,
                    'twitter': twitter,
                    'google': google
                };
              $window.location.href = socialLoginUrlMap[socialLink];
             }
          };
        //init facebook
        window.FacebookService.init({
                appId: $scope.pageData.facebookAppId
            }, function(err){
            if (err) { return; }
        });

        //forgot password
        $scope.forgotPassword = function(){
            $scope.data.email = $scope.data.username ? $scope.data.username : '';
            showModal('forgotPassword');
        };

        //show forgot password modal if user lands on login page with showForgotPassword=true. This is when user is requesting for a new token which happens when the token has expired during reset password flow
        var showForgotPassword = $localStorage.showForgotPasswordModal;

        $scope.sendPasswordLink = function(){
            $scope.data.forgotPasswordForm.$submitted = true;
            var postData = {
                email: $scope.data.email
            };
            if(!$scope.data.email){
                return;
            }
            $scope.data.forgotPasswordForm.pendingSubmit = true;
            jvLoginService.sendPasswordLink(postData,function(response){
                $scope.data.forgotPasswordForm.pendingSubmit = false;
                if(response.status ===200 && response.data.success){
                     $scope.$emit('showMessageBar', {message: response.data.confirmationMessage, duration: 10000 , position: 'top'} );
                }else{
                    $scope.$emit('showMessageBar', {message: response.data.errorMessage, duration: 10000, position: 'top'} );
                }
                $scope.hideModals('forgotPassword');
                $scope.data.forgotPasswordForm.$submitted = false;
                //remove query param from browser
                if(showForgotPassword){
                    $timeout(function(){
                        $window.location.reload();
                    },500);
                }
            });
        };
        //check for googleRecaptcha
        if($scope.pageData.recaptcha === 'googleRecaptcha'){
            $timeout(function(){
                var captchaObject = JSON.parse($scope.pageData.captchaSettings);
                if(angular.isDefined(grecaptcha)){
                    $scope.data.grecaptcha = grecaptcha;
                    $scope.data.grecaptcha.render('captcha', {sitekey: captchaObject.siteKey, theme: 'light'});
                }
            },500);
        }
        delete $localStorage.showForgotPasswordModal;
        $scope.pageData.loginUrl = appendReturnURL($scope.pageData.loginUrl,true);
        if(showForgotPassword){
            $scope.forgotPassword();
        }

        $scope.data.socialAccounts.socialProfiles = angular.copy($scope.pageData.socialProfiles);
        //users can land on login.html from old login page trying to do a SSO login
        var ssoLogin = $window.location.search.split('?showSSOLogin=')[1];
        if(ssoLogin){
            $scope.data.ssologin = true;
        }
        var userRole = $window.location.search.split('?role=')[1];
        $scope.pageData.userRole = userRole || 'em';
        $scope.pageData.marketingBannerUrl = $scope.pageData.employeeLoginBannerURL;
        if(userRole === 'js'){
            $scope.pageData.marketingBannerUrl = $scope.pageData.jobseekerLoginBannerURL;
        }
    }
]);
